import { render, staticRenderFns } from "./EditChannelPatternForm.vue?vue&type=template&id=2c9a5cb8&"
import script from "./EditChannelPatternForm.vue?vue&type=script&lang=js&"
export * from "./EditChannelPatternForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports